module.exports = __webpack_public_path__ + "static/media/brown-wall-lights.7ee767ff.jpg";